import { action } from 'typesafe-actions';

import { WalletHistoryTypes, WalletHistoryInterface } from './types';

// Get Wallet History
export const getWalletHistoryRequest = (payload: object) =>
  action(WalletHistoryTypes.GET_HISTORY_REQUEST, payload);

export const getWalletHistorySuccess = (payload: {
  walletHistoryList: WalletHistoryInterface;
  totalCount: number;
}) => action(WalletHistoryTypes.GET_HISTORY_SUCCESS, payload);

export const getWalletHistoryFailure = () =>
  action(WalletHistoryTypes.GET_HISTORY_FAILURE);
